var exports = {
  "k": "xe533113f--e9c387--container",
};

module.exports = exports;
